import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useQueryClient } from '@tanstack/react-query'
import {
    AddObjectToStarred,
    ListStarredObjectKeys,
    RemoveObjectFromStarred,
} from '..'
import { RemoveStarredParams } from '@/modules/Drive/types'

// Get list of starred object keys
export const fetchStarredObjectKeys = async (uuid: string) => {
    return ListStarredObjectKeys(uuid).then((res) => res.results)
}

// Mutation: remove an object from starred
export const useRemoveStarredMutation = (
    uuid: string | undefined,
    setStarredObjectKeys?: (keys: string[]) => void
) => {
    const queryClient = useQueryClient()
    return useMutationWithHandler(
        {
            mutationFn: ({ uuid, objectName }: RemoveStarredParams) => {
                if (!uuid) {
                    throw new Error('UUID is required')
                }
                return RemoveObjectFromStarred(uuid, objectName)
            },
        },
        {
            reactQueryKeys: QUERY_KEYS.DRIVE_STARRED_LIST,
            showSuccessToast: false,
            showErrorToast: false,
            onSuccess: async () => {
                queryClient.invalidateQueries({ queryKey: ['starredList'] })
                if (uuid && setStarredObjectKeys) {
                    const updatedKeys = await fetchStarredObjectKeys(uuid)
                    setStarredObjectKeys(updatedKeys)
                }
            },
        }
    )
}

// Mutation: add an object to starred
export const useAddStarredMutation = (
    uuid: string | undefined,
    setStarredObjectKeys?: (keys: string[]) => void
) => {
    const queryClient = useQueryClient()
    return useMutationWithHandler(
        {
            mutationFn: AddObjectToStarred,
        },
        {
            reactQueryKeys: QUERY_KEYS.DRIVE_STARRED_LIST,
            showSuccessToast: false,
            showErrorToast: false,
            onSuccess: async () => {
                queryClient.invalidateQueries({ queryKey: ['starredList'] })
                if (uuid && setStarredObjectKeys) {
                    const updatedKeys = await fetchStarredObjectKeys(uuid)
                    setStarredObjectKeys(updatedKeys)
                }
            },
        }
    )
}
